export const state = {
    media: [],
};